import { createSlice } from '@reduxjs/toolkit';
import { AuthState } from '@/store/types/authTypes';

const initialAuthState: AuthState = {
	isUserLoggedIn: true,
};

const authSlice = createSlice({
	name: 'auth',
	initialState: initialAuthState,
	reducers: {
		// setUserLoggedIn(state, action) {
		// 	state.isUserLoggedIn = action.payload;
		// },
	},
});

// No actions exported yet
export default authSlice.reducer;